import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-stacked-card-field',
  templateUrl: './stacked-card-field.component.html',
  styleUrls: ['./stacked-card-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StackedCardFieldComponent {
  @Input() label = '';
}
